import * as React from 'react';
import { Image } from 'antd';
import ResolvedImage from '../resolved_image/ResolvedImage';

/**
 * Thumbnails for images that are already uploaded and addressed by absolute URL — the
 * "Send this photo?" confirmation being the main one.
 *
 * Every tile goes through `ResolvedImage`, so an iPhone photo shows a "Converting…" placeholder
 * and swaps in the JPEG derivative when it lands. Handing the raw URL to antd's `Image` renders a
 * broken icon instead: the object is a HEIC and no browser but Safari can decode it.
 */
export class ImageThumbnails extends React.Component<any> {
	state = {
		lightboxIsOpen: false,
		currentIndex: 0,
	};

	handleViewChange = (idx) => {
		this.setState({ currentIndex: idx });
	};

	openLightbox = (currentIndex = 0) => {
		this.setState({ lightboxIsOpen: true, currentIndex });
	};

	closeLightbox = () => {
		this.setState({ lightboxIsOpen: false });
	};

	render() {
		const { photoStrings = [], imageWidth, imageHeight, style = {}, ...props } = this.props;
		return (
			<div className="ProtectedImageThumbnails" style={{ display: 'flex', ...style }} {...props}>
				<Image.PreviewGroup>
					{photoStrings.map((photoString, idx) => (
						<ResolvedImage
							key={idx}
							url={photoString}
							width={imageWidth}
							height={imageHeight}
							style={{ marginLeft: idx === 0 ? 0 : 8 }}
						/>
					))}
				</Image.PreviewGroup>
			</div>
		);
	}
}
